import request from '@/utils/request'

export function main(id) {
  return request({
    url: `/api/app/browser/main-assets/${id}`,
    method: 'get'
  })
}

export function table(data) {
  return request({
    url: '/api/app/browser/asset-transaction',
    method: 'post',
    data,
  })
}